<script lang="ts" setup>
import type { ToggleContainerProps } from './index';

import { cn } from '@/utils';

import IconMaterialSymbolsLightExpandLess from '~icons/material-symbols-light/expand-less';
import IconMaterialSymbolsLightExpandMore from '~icons/material-symbols-light/expand-more';

const props = withDefaults(defineProps<ToggleContainerProps>(), {
	defaultExpanded: false,
	modelValue: undefined,
	containerClass: '',
	buttonClass: '',
	contentClass: '',
	expandText: 'Ver mais',
	collapseText: 'Ver menos'
});

const emit = defineEmits<{
	'update:modelValue': [value: boolean];
}>();

const expanded = ref(props.modelValue || props.defaultExpanded);

const toggleExpand = () => {
	expanded.value = !expanded.value;
	emit('update:modelValue', expanded.value);
};

watch(
	() => props.modelValue,
	newValue => {
		if (newValue !== undefined && newValue !== expanded.value) {
			expanded.value = newValue;
		}
	}
);

const contentWrapperClasses = computed(() => {
	const stateClasses = expanded.value
		? 'max-h-[500px] opacity-100'
		: 'max-h-0 overflow-hidden opacity-0';
	return cn('transition-all duration-300 ease-in-out', stateClasses);
});

defineExpose({
	isExpanded: readonly(expanded),
	toggle: toggleExpand
});
</script>

<template>
	<div :class="containerClass">
		<div :class="contentWrapperClasses">
			<div :class="contentClass">
				<slot name="content" :is-expanded="expanded" />
			</div>
		</div>

		<div :class="buttonClass" @click="toggleExpand">
			<slot name="button" :is-expanded="expanded" :toggle="toggleExpand">
				<button
					type="button"
					class="flex items-center gap-1 self-start text-sm text-primary underline decoration-primary/20 underline-offset-8"
				>
					<IconMaterialSymbolsLightExpandLess v-if="expanded" class="size-5" />
					<IconMaterialSymbolsLightExpandMore v-else class="size-5" />
					<span>{{ expanded ? collapseText : expandText }}</span>
				</button>
			</slot>
		</div>
	</div>
</template>

<!-- eslint-disable-next-line custom-rules/no-style-tag -->
<style></style>
